import React from "react";
import ProfileAvatar from "@/components/ProfileAvatar";
import FounderBadge from "@/components/FounderBadge";

/**
 * A single Vibe Feed post. Shows the 'Sovereign Founder' badge next to the author's name
 * (and a small gold mark on their avatar) whenever the post's author is the Root Admin.
 */
const FeedItem = ({ vibe }) => {
  const v = vibe;
  return (
    <div className="mb-6 break-inside-avoid surface rounded-[1.5rem] overflow-hidden card-soft" data-testid="vibe-card">
      {v.image_base64 && <img src={`data:image/png;base64,${v.image_base64}`} alt="" className="w-full object-cover" />}
      <div className="p-4">
        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
          <ProfileAvatar name={v.author_name} color={v.accent_color || "#c9a24a"} sizeClass="w-6 h-6" textClass="text-xs" isRootAdmin={!!v.author_is_root_admin} />
          <span className="text-sm font-medium">{v.author_name}</span>
          {v.author_is_root_admin && <FounderBadge size="xs" />}
        </div>
        {v.content && <p className="text-sm text-foreground/90">{v.content}</p>}
        {v.link && <a href={v.link} target="_blank" rel="noreferrer" className="text-xs text-primary hover:underline">{v.link}</a>}
      </div>
    </div>
  );
};

export default FeedItem;
